<template>
    <div class="space-wrapper">
        <TrackingRow v-for="(interaction, i) in space.interactions" :key="'i_'+ i" :showReporting="showReporting"
                     :data="interaction" type="interaction" :technical-name-prefix="technicalName" :sticky="sticky"
                     @delete="$emit('interactionDeleteClicked', {
                             moduleId: null,
                             interactionId: i
                         })"
                     @copy="$emit('interactionCopyClicked', {
                             moduleId: null,
                             interactionId: i
                         })"
                     :spaceIndex=spaceIndex :moduleIndex="null" :interactionIndex="i" :space="space"
        ></TrackingRow>
        <div v-if="space.modules.length !== 0">
            <ModuleSection v-for="(module, i) in space.modules" :key="'m_'+i" :titleEditable="titleEditable"
                           :space-id="spaceIndex" :module-id="i" :sticky="sticky"
                           :showActions="showActions" :showMoveIcons="showMoveIcons"
                           @add="$emit('moduleAddClicked', i)" @duplicate="copyModule(i)"
                           @delete="$emit('moduleDeleteClicked', i)" :space="space">
                <TrackingRow v-for="(modInteraction, j) in module.interactions" :key="'m_'+i+'_'+j"
                             :showReporting="showReporting" :sticky="sticky"
                             :data="modInteraction" type="interaction" @delete="$emit('interactionDeleteClicked', {
                             moduleId: i,
                             interactionId: j
                         })"
                             @copy="$emit('interactionCopyClicked', {
                             moduleId: i,
                             interactionId: j
                         })"
                             :technical-name-prefix="technicalName + '_' + module.technical_name" :space="space"
                             :spaceIndex="spaceIndex" :moduleIndex="i" :interactionIndex="j"
                ></TrackingRow>
            </ModuleSection>
        </div>
        <TrackingRow v-if="editAllowed" :data="'Tracking hinzufügen'" type="button" :sticky="sticky"
                     @click="$emit('addClicked')"></TrackingRow>
    </div>
</template>

<script>
    import TrackingRow from "./TrackingRow";
    import ModuleSection from "./ModuleSection";

    export default {
        name: "Space",
        components: {ModuleSection, TrackingRow},
        props: {
            space: {
                type: Object,
                required: true
            },
            spaceIndex: {
                type: Number
            },
            technicalName: {
                type: String,
                default: ''
            },
            showReporting: {
                type: Boolean,
                default: true
            },
            sticky: {
                type: Boolean,
                default: false
            },
            showActions: {
                type: Boolean,
                default: true
            },
            showMoveIcons: {
                type: Boolean,
                default: true
            },
            titleEditable: {
                type: Boolean,
                default: false
            },
        },
        computed: {
            editAllowed() {
                let status = this.$store.state.trackingList.data.status;
                if (typeof status !== "undefined") {
                    if (status.indexOf('eingebaut') !== -1) {
                        //status is pink
                        if (Object.prototype.hasOwnProperty.call(this.space, 'initial') && this.space.initial) {
                            //initial space
                            return false;
                        }
                    }
                }
                return this.$route.name !== 'showReporting';
            }
        },
        methods: {
            copyModule(id) {
                this.$store.commit('trackingList/copyModule', {
                    spaceId: this.spaceIndex,
                    moduleId: id
                });
                window.requestAnimationFrame(() => {
                    this.$emit('afterCopyModule');
                });
            }
        }
    }
</script>

<style scoped>
    .space-wrapper {
        position: relative;
    }
</style>